import React from 'react'
import { Table } from 'react-bootstrap'

const HeaderTable = ({ headers }) => {
    return (
        <div className="table-responsive">
            <Table id="basic-table" className="table mb-0 table-striped" role="grid">
                <tbody>
                    {headers &&
                        headers.map((header, index) => (
                            <tr key={index}>
                                <td style={{ width: '50px', height: '66px' }}>
                                    <div className="d-flex align-items-center">
                                        <small className="mb-0">{index + 1}</small>
                                    </div>
                                </td>
                                <td className="small text-blue-300">{header}</td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </div>
    )
}

export default HeaderTable
